import React, { useState } from 'react';
import useAuthGuard from '../hooks/useAuthGuard';
import Layout from '../components/Layout';
import { API_BASE_URL } from '../config';
import apiFetch from '../utils/apiFetch';

export default function StoreImport() {
  useAuthGuard();

  const [fileUrl, setFileUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);
    setError('');

    try {
      const res = await apiFetch(`${API_BASE_URL}/admin/import/stores`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fileUrl }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.message || data.error || `HTTP ${res.status}`);
      }

      const data = await res.json();
      setResult(data.data || data);
      setFileUrl('');
    } catch (e) {
      setError(e.message || 'Import failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="mb-4">
        <h2 className="mb-1">Store Import</h2>
        <p className="text-muted mb-0">Import stores from a CSV file</p>
      </div>

      <div className="row">
        <div className="col-12 col-lg-8">
          <div className="card shadow-sm border-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="fileUrl" className="form-label">
                    CSV File URL
                  </label>
                  <input
                    type="url"
                    id="fileUrl"
                    className="form-control"
                    placeholder="https://example.com/stores.csv"
                    value={fileUrl}
                    onChange={(e) => setFileUrl(e.target.value)}
                    required
                  />
                  <div className="form-text">
                    Enter the URL of the CSV file containing store data.
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading || !fileUrl}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                      Importing...
                    </>
                  ) : (
                    'Start Import'
                  )}
                </button>
              </form>
            </div>
          </div>

          {error && (
            <div className="alert alert-danger mt-3" role="alert">
              {error}
            </div>
          )}

          {result && (
            <div className="alert alert-success mt-3" role="alert">
              <h6 className="alert-heading">Import Queued</h6>
              <p className="mb-0">{result.message || 'Import has been queued for processing.'}</p>
            </div>
          )}
        </div>

        <div className="col-12 col-lg-4">
          <div className="card shadow-sm border-0">
            <div className="card-body">
              <h6>CSV Format</h6>
              <p className="small text-muted mb-2">
                The CSV file should contain the following columns:
              </p>
              <ul className="small text-muted mb-0">
                <li>name (required)</li>
                <li>address (required)</li>
                <li>latitude</li>
                <li>longitude</li>
                <li>phone</li>
                <li>website</li>
                <li>opening_hours</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
